<div class="sent-rejected home-section">
    <div class="title-section">
        <div class="inbox-marker"></div>
        <div class="div-label">
            <mat-label class="label-title">Rechazados</mat-label>
            <div *ngIf="canPermissionTeam" >
                <a class="change-inbox" (click)="showRejectedTeam()">
                    Cambiar a Bandejas de mi Equipo
                </a>
            </div>
            
        </div>
    </div>
    <div class="search-section">
        <mat-form-field class="search-well-card dense-3">
            <mat-label class = "label-well">Buscá un pozo</mat-label>
            <input type="text" aria-label="Well" matInput #searchText (keyup.enter)="getHandoversHomeRejectedPersonalWithFilter(searchText.value)">
            <span matSuffix class="cursor-pointer" (click)="getHandoversHomeRejectedPersonalWithFilter(searchText.value)">
              <mat-icon class="material-icons-outlined" aria-hidden="false" aria-label="Account">search</mat-icon>
            </span>
        </mat-form-field> 
    </div>
    <div class="content-section">
        <div class="handovers" *ngIf="totalHandoversRejectedPersonal != 0">
            <app-handover-card *ngFor="let handover of handoversRejectedPersonal" [handover]="handover" 
            (reload)="eventReload($event)" [destinationLabel]="destinationLabel"></app-handover-card>
        </div>
        <div class="empty-content" *ngIf="totalHandoversRejectedPersonal == 0">
            <div *ngIf="this.textSearch == ''">
                <p class="rejected-empty">No hay Handovers aún</p>
                <p class="rejected-empty-text">Aquí podrás visualizar los <br> Handovers que hayas rechazado</p>
            </div>
            <div *ngIf="this.textSearch != ''">
                <p class="rejected-empty">No hay handovers para el filtro aplicado</p>
            </div>
        </div>
    </div>
</div>